export const QUERY_RETRY_COUNT = 1;
